import React, {useState,useEffect} from 'react';
import useStyles from './Styles';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
//import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
//import Checkbox from '@mui/material/Checkbox';
import Select,{SelectChangeEvent} from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import {Tools} from './Tools';
import {Inc,Dataset,LotterySearchCondition,SortOption} from './Inc';
import Title from './Title';
import AppBank from './AppBank';

interface LotteryListSearchProps {
    update(cond:LotterySearchCondition,page:number): void,
	bankKey:string,
	bank:AppBank,	
}

const LotteryListSearch = (props:LotteryListSearchProps)=> {
    const classes = useStyles();
    const [states,setStates] = useState(Inc.defaultLotterySearchCondition());

    const update = ()=>{
		props.bank.set(props.bankKey,JSON.stringify(states));
        props.update(states,1);
    }
	const handleChange = (name: keyof LotterySearchCondition) => (event: React.ChangeEvent<HTMLInputElement>) => {
		setStates({ ...states, [name]: event.target.value });
    };
	const handleChangeNumber = (name: keyof LotterySearchCondition) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setStates({ ...states, [name]: Tools.toHan(event.target.value) });
        //setStates({ ...states, [name]: event.target.value });
	};    
	const handleChangeSelect = (name: keyof LotterySearchCondition) => (event: SelectChangeEvent) => {
		setStates({ ...states, [name]: event.target.value });
    };
	const handleChangeOption = (name: keyof SortOption) => (event: SelectChangeEvent) => {
        let option = states.option;
        option[name] = event.target.value;
		setStates({ ...states, "option": option});
    };
	//const handleChangeCheckboxes = (name: keyof LotterySearchCondition,index:number) => (event: React.ChangeEvent<HTMLInputElement>) => {
	//	let boolList:boolean[] = [];
	//	let idList:string[] = [];
	//	let blName:string = "";
	//	let datas:Dataset[] = [];
	//	if( name==="order_status_ids" ){
	//		boolList = states.order_status_bls;
	//		blName = "order_status_bls";
	//		datas = Inc.lotteryOrderStatus;
	//	}
	//	if( blName!=="" ){
	//		if( event.target.checked ){
	//			boolList[index] = true;
	//		} else {
	//			boolList[index] = false;
	//		}
	//		for( let i=0 ; i<boolList.length ; i++ ){
	//			if( boolList[i] ){
	//				idList.push( datas[i].id );
	//			}
	//		}
	//		setStates({ ...states, [blName]: boolList, [name]: idList });
	//	}
	//};
	const resetCondition = ()=>{
		setStates(Inc.defaultLotterySearchCondition());
	}
    
	//const checkboxes = (id:keyof LotterySearchCondition,list:Dataset[])=>{
	//	const tmp = list.map( (data:Dataset,index:number)=>{
	//		const key = id+index;
	//		let v:boolean = false;
	//		if( id==="order_status_ids" ){
	//			v = states.order_status_bls[index];
	//		}
	//		return (
	//			<FormControlLabel
	//		    	key={key}
	//				control={
	//				<Checkbox
	//					checked={v}
	//					onChange={handleChangeCheckboxes(id,index)}
	//					value={String(data.id)}
	//					color="secondary"
	//					className={classes.checkbox}
	//				/>
	//				}
	//				label={data.label}
	//			/>
	//		);
	//	});
	//	return (
	//		<div className={classes.checkboxes}>
	//			{tmp}
	//		</div>
	//	)
    //};

    useEffect( ()=>{
		if( props.bank.has(props.bankKey) ){
			//console.log("load");
			const cond = JSON.parse(props.bank.get(props.bankKey));
			setStates(cond);
			props.update(cond,1);
		} else {
			props.update(states,1);
		}
    },[])
    
    const years = Tools.getSelectYears();
    const months = Tools.getSelectMonths();
    const orders:Dataset[] = [
        {
            id:"order_time",
            label:"受注日時",
        },
        {
            id:"plan_id",
            label:"抽選ID",
        },
        {
            id:"item_name",
            label:"商品名",
        },
    ]
    //const targets:Dataset[] = [
    //    {
    //        id:"order_time",
    //        label:"受注日",
    //    },
    //    {
    //        id:"delivery_date",
    //        label:"発送予定日",
    //    },
    //    {
    //        id:"received_date",
    //        label:"入金日",
    //    },
    //]

    //console.log("lottery::list::search");

    let error = false;
    let error_item_id = false;
    let error_plan_id = false;
    if( states.item_id!=="" && !Tools.isNumber(states.item_id) ){
        error_item_id = true;
    }
    if( states.plan_id!=="" && !Tools.isNumber(states.plan_id) ){
        error_plan_id = true;
    }
    if( error_item_id || error_plan_id ){
        error = true;
    }
	
	return (
		<div id="lottery_list_search">
            
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Title text="検索条件" size={2}/>
                </Grid>
                <Grid item xs={6}>
                    <div className={classes.searchButtons}>
                        <Button variant="outlined" color="primary" onClick={update} disabled={error}><SearchIcon/>検索</Button>
                    </div>
                </Grid>
                <Grid item xs={6} md={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>商品名</FormLabel>
                        <TextField
                            className={classes.input}
                            inputProps={{
                                'aria-label': 'Description',
                            }}
                            margin="none"
                            value={states.item_name}
							variant='standard'
                            onChange={handleChange("item_name")}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6} md={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>商品ID</FormLabel>
                        <TextField
                            className={classes.input}
                            inputProps={{
                                'aria-label': 'Description',
                            }}
                            margin="none"
                            value={states.item_id}
							variant='standard'
                            onChange={handleChangeNumber("item_id")}
                        />
                        {error_item_id &&
                        <FormHelperText>数字で入力して下さい</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>抽選結果</FormLabel>
                            <Select
                                value={states.lottery_result_id}
                                onChange={handleChangeSelect('lottery_result_id')}
                                margin="none"
								variant='standard'
                                className={classes.select}
                            >
                                <MenuItem key="result0" value="">　</MenuItem>
                                {Inc.lotteryResults.map((option:Dataset,index:number) => {
                                    const key = "result"+index;
                                    return (
                                        <MenuItem key={key} value={option.id}>
                                            {option.label}
                                        </MenuItem>
                                    )
                                })}
                            </Select>

                    </FormControl>
                </Grid>
                <Grid item xs={6} md={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>抽選ID</FormLabel>
                        <TextField
                            className={classes.input}
                            inputProps={{
                                'aria-label': 'Description',
                            }}
                            margin="none"
                            value={states.plan_id}
							variant='standard'
                            onChange={handleChangeNumber("plan_id")}
                        />
                        {error_plan_id &&
                        <FormHelperText>数字で入力して下さい</FormHelperText>
                        }
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                    <FormGroup row>
                        <FormControl className={classes.formControl} >
                            <FormLabel component="label" className={classes.formLabel}>受注月</FormLabel>
                            
                            <Select
                                value={states.date_year}
                                onChange={handleChangeSelect('date_year')}
                                inputProps={{
                                    name: 'year',
                                    id: 'year-simple',
                                }}
                                margin="none"
								variant='standard'
                                className={classes.select}
								style={{width:'6em'}}
                            >
                                <MenuItem key="year0" value="">　</MenuItem>
                                {years.map((option:Dataset,index:number) => {
                                    const key = "year"+index;
                                    return (
                                        <MenuItem key={key} value={option.id}>
                                            {option.label}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>

                        <FormControl className={classes.formControl}>
                            <FormLabel component="label" className={classes.formLabel}>　</FormLabel>
                            <Select
                                value={states.date_month}
                                onChange={handleChangeSelect('date_month')}
                                inputProps={{
                                    name: 'month',
                                    id: 'month-simple',
                                }}
                                margin="none"
								variant='standard'
                                className={classes.select}
								style={{width:'5em'}}
                            >
                                <MenuItem key="month0" value="">　</MenuItem>
                                {months.map((option:Dataset,index:number) => {
                                    const key = "month"+index;
                                    return (
                                        <MenuItem key={key} value={option.id}>
                                            {option.label}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                    </FormGroup>
                </Grid>
                <Grid item xs={4} md={6} lg={6}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>表示基準</FormLabel>
                        
                        <Select
                            value={states.option.order}
                            onChange={handleChangeOption('order')}
                            inputProps={{
                                name: 'order',
                                id: 'order-simple',
                            }}
                            margin="none"
							variant='standard'
                            className={classes.select}
                        >
                            {orders.map((option:Dataset,index:number) => {
                                const key = "order"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={4} md={6} lg={6}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>表示順</FormLabel>
                        
                        <Select
                            value={states.option.sort}
                            onChange={handleChangeOption('sort')}
                            inputProps={{
                                name: 'sort',
                                id: 'sort-simple',
                            }}
                            margin="none"
							variant='standard'
                            className={classes.select}
                        >
                            {Inc.sorts.map((option:Dataset,index:number) => {
                                const key = "sort"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={4} md={12} lg={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>表示件数</FormLabel>
                        
                        <Select
                            value={states.option.per_page}
                            onChange={handleChangeOption('per_page')}
                            inputProps={{
                                name: 'per_page',
                                id: 'per_page-simple',
                            }}
                            margin="none"
							variant='standard'
                            className={classes.select}
                        >
                            {Inc.perPages.map((option:Dataset,index:number) => {
                                const key = "per_page"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>

            </Grid>
            <Button variant="outlined" fullWidth={true} className={classes.buttonReset} onClick={resetCondition}><DeleteIcon/>検索条件のリセット</Button>
		</div>
	);
}

export default LotteryListSearch;
